<div class="faq">
  <div class="faq__duvidas" *ngFor="let duvida of faq; let i = index">
    <lovers-accordion
      *ngIf="i < quantidadePerguntas"
      [titulo]="definirTitulo(duvida.pergunta, i)"
    >
      <p class="faq__resposta" [innerHTML]="duvida.resposta | boldColor"></p>
    </lovers-accordion>
  </div>
  <div
    class="faq__ver__mais"
    *ngIf="verMais && faq.length >= quantidadePerguntas"
    (click)="onClickVerMais()"
  >
    <p class="ver__mais">
      <img class="ver__mais__icone" src="assets/images/icons/mais.png" />
      Ver mais perguntas
    </p>
  </div>
</div>
